import { combineReducers } from 'redux';
import apikeys from './apikeys';
import filters from './filters';

export default combineReducers({ 
    apikeys,
    filters
});